import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {RaisedButton} from "material-ui";

import StevedoringData from './StevedoringData';
import { getPort, clearPort } from 'actions/regions/ports';

const styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
};

import CheckDiffText from '../CheckDiffText';

const ShowDiffEmails = ({emails, providerEmails}) => {
    let resultArray = [];

    for (let i = 0; i <= emails.length - 1; i++) {
        resultArray.push(<div key={i} className='phone'>
            <CheckDiffText newValue={providerEmails[i]} oldValue={emails[i]} />
        </div>);
    }

    if (providerEmails.length > emails.length) {
        for (let i = emails.length; i <= providerEmails.length - 1; i++) {
            resultArray.push(<div
                key={i}
                className='email'>
                <CheckDiffText
                    newValue={providerEmails[i]}
                    oldValue={null}
                />
            </div>);
        }
    }

    return resultArray;
};

const ShowDiffPhones = ({ phones, providerPhones }) => {
    let resultArray = [];

    for (let i = 0; i <= phones.length - 1; i++) {
        resultArray.push(<div
            key={i}
            className='phone'>
            <CheckDiffText
                newValue={providerPhones[i] ? providerPhones[i].code : null}
                oldValue={phones[i].code}
            />
            <CheckDiffText
                newValue={providerPhones[i] ? providerPhones[i].phone : null}
                oldValue={phones[i].phone}
            />
        </div>);
    }

    if (providerPhones.length > phones.length) {
        for (let i = phones.length; i <= providerPhones.length - 1; i++) {
            resultArray.push(<div
                key={i}
                className='phone'>
                <CheckDiffText
                    newValue={providerPhones[i].code}
                    oldValue={null}
                />
                <CheckDiffText
                    newValue={providerPhones[i].phone}
                    oldValue={null}
                />
            </div>);
        }
    }

    return resultArray;
};


class ServiceProvider extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { serviceProvider, rejectServiceProvider, approveServiceProvider  } = this.props;

        return (
            <Fragment>
                {
                    serviceProvider.status === 'change'
                        ?
                        <div className="table-row">
                            <div className="table-col info">
                                <div className='name'>
                                    {
                                        serviceProvider.activities.includes('Stevedoring Company') 
                                        || 
                                        serviceProvider.provider.activities.includes('Stevedoring Company') 
                                            ?
                                            <StevedoringData
                                                serviceProvider={serviceProvider}
                                            />
                                            :
                                            <CheckDiffText
                                                newValue={serviceProvider.provider.activities.join(',')}
                                                oldValue={serviceProvider.activities.join(',')}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="table-col">
                                <div className='name company'>
                                    <CheckDiffText
                                        newValue={serviceProvider.provider.name}
                                        oldValue={serviceProvider.name}
                                    />
                                </div>
                            </div>
                            <div className="table-col">
                                <div className="list">
                                    <ShowDiffEmails
                                        emails={serviceProvider.emails}
                                        providerEmails={serviceProvider.provider.emails}
                                    />
                                </div>

                                <div className="list">
                                    <ShowDiffPhones
                                        phones={serviceProvider.phones}
                                        providerPhones={serviceProvider.provider.phones}
                                    />
                                </div>

                                <div className='name'>
                                    <CheckDiffText
                                        newValue={serviceProvider.provider.address}
                                        oldValue={ serviceProvider.address}
                                    />
                                </div>

                                <div className='name'>
                                    PIC:
                                    <CheckDiffText
                                        newValue={serviceProvider.provider.PIC}
                                        oldValue={serviceProvider.PIC}
                                    />
                                </div>
                            </div>
                            <div className="table-col edit">
                                <div>
                                    <RaisedButton
                                        label={'Approve'}
                                        style={styles.btnSubmit.style}
                                        labelStyle={styles.btnSubmit.labelStyle}
                                        labelPosition="before"
                                        backgroundColor="#a4c639"
                                        onClick={() => {
                                            approveServiceProvider(serviceProvider)
                                        }}
                                    />
                                </div>
                                <div>
                                    <RaisedButton
                                        label={'Reject'}
                                        style={styles.btnSubmit.style}
                                        labelStyle={styles.btnSubmit.labelStyle}
                                        labelPosition="before"
                                        backgroundColor="#f00"
                                        onClick={() => {
                                            rejectServiceProvider(serviceProvider)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }

                {
                    serviceProvider.status === 'remove'
                        ?
                        <div className="table-row dirty-element">
                            <div className="table-col info">
                                <div className='name'>
                                    {
                                        serviceProvider.activities.includes('Stevedoring Company')
                                            ?
                                            <StevedoringData
                                                serviceProvider={serviceProvider}
                                            />
                                            :
                                            <CheckDiffText
                                                newValue={null}
                                                oldValue={serviceProvider.activities}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="table-col">
                                <div className='name company'>
                                    <CheckDiffText
                                        newValue={null}
                                        oldValue={serviceProvider.name}
                                    />
                                </div>
                            </div>
                            <div className="table-col">
                                <div className="list">
                                    {
                                        serviceProvider.emails.map((email, emailIndex) => {
                                            return (<div
                                                key={emailIndex}
                                                className='email'>
                                                <CheckDiffText
                                                    newValue={null}
                                                    oldValue={email}
                                                />
                                            </div>)
                                        })
                                    }
                                </div>

                                <div className="list">
                                    {
                                        serviceProvider.phones.map((phone, phoneIndex) => {
                                            return (<div key={phoneIndex} className='phone'>
                                                <CheckDiffText
                                                    newValue={null}
                                                    oldValue={phone.code}
                                                />
                                                <CheckDiffText
                                                    newValue={null}
                                                    oldValue={phone.phone}
                                                />
                                            </div>)
                                        })
                                    }
                                </div>

                                <div className='name'>
                                    <CheckDiffText
                                        newValue={null}
                                        oldValue={serviceProvider.address}
                                    />
                                </div>

                                <div className='name'>
                                    PIC:
                                    <CheckDiffText
                                        newValue={null}
                                        oldValue={serviceProvider.PIC}
                                    />
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }

                {
                    serviceProvider.status === 'normal' || serviceProvider.status === 'new'
                        ?
                        <div className={ serviceProvider.status === 'new' ? "dirty-element table-row" :  "table-row"}>
                            <div className="table-col info">
                                <div className='name'>
                                    {
                                        serviceProvider.activities.includes('Stevedoring Company')
                                            ?
                                            <StevedoringData
                                                serviceProvider={serviceProvider}
                                            />
                                            :
                                            serviceProvider.activities.join(',')
                                    }
                                </div>
                            </div>
                            <div className="table-col">
                                <div className='name company'>
                                    {serviceProvider.name}
                                </div>
                            </div>
                            <div className="table-col">
                                <div className="list">
                                    {
                                        serviceProvider.emails.map((email, emailIndex) => {
                                            return (<div
                                                key={emailIndex}
                                                className='email'>
                                                {email}
                                            </div>)
                                        })
                                    }
                                </div>

                                <div className="list">
                                    {
                                        serviceProvider.phones.map((phone, phoneIndex) => {
                                            return (<div key={phoneIndex} className='phone'>
                                                {`${phone.code} ${phone.phone}`}
                                            </div>)
                                        })
                                    }
                                </div>

                                <div className='name'>
                                    {serviceProvider.address}
                                </div>

                                <div className='name'>
                                    PIC:
                                    {serviceProvider.PIC}
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }
            </Fragment>
        );
    }
}

ServiceProvider.propTypes = {
    port: PropTypes.object,
};

ServiceProvider.defaultProps = {
    port: {},
};

export default connect(
    (state, { serviceProvider, rejectServiceProvider, approveServiceProvider }) => {
        return {
            serviceProvider,
            rejectServiceProvider,
            approveServiceProvider

        };
    },
    dispatch => bindActionCreators({
        getPort,
        clearPort,
    }, dispatch),
)(ServiceProvider);


// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/ServiceProviders/ServiceProvider.jsx